// Angular modules
import { HttpClient }            from '@angular/common/http';
import { HttpClientModule }      from '@angular/common/http';
import { ErrorHandler }          from '@angular/core';
import { NgModule }              from '@angular/core';
import { BrowserModule }         from '@angular/platform-browser';

// Ionic modules
import { GoogleAnalytics }       from '@ionic-native/google-analytics';
import { IonicApp }              from 'ionic-angular';
import { IonicErrorHandler }     from 'ionic-angular';
import { IonicModule }           from 'ionic-angular';

// External modules
import { AddToCartPage }         from './pages/add-to-cart/add-to-cart';
import { CalculatorResultsPage } from './pages/calculator-results/calculator-results';
import { CartPage }              from './pages/cart/cart';
import { CompensatedVacuumPage } from './pages/compensated-vacuum/compensated-vacuum';
import { ContactPage }           from './pages/contact/contact';
import { CreateAccountPage }     from './pages/create-account/create-account';
import { DirectSearchPage }      from './pages/direct-search/direct-search';
import { FindCompetitorPage }    from './pages/find-competitor/find-competitor';
import { GasFlushingPage }       from './pages/gas-flushing/gas-flushing';
import { GascomsuptionPage }     from './pages/gascomsuption/gascomsuption';
import { GasmixturesPage }       from './pages/gasmixtures/gasmixtures';
import { GasselectorPhonePage }  from './pages/gasselector-phone/gasselector-phone';
import { GasselectorPage }       from './pages/gasselector/gasselector';
import { HomeMenuPage }          from './pages/home-menu/home-menu';
import { HomePage }              from './pages/home/home';
import { InformationPage }       from './pages/information/information';
import { KeyPointDetailPage }    from './pages/key-point-detail/key-point-detail';
import { KeyPointsPage }         from './pages/key-points/key-points';
import { LegalTermsPage }        from './pages/legal-terms/legal-terms';
import { MixturesResultPage }    from './pages/mixtures-result/mixtures-result';
import { MoleculeResultPage }    from './pages/molecule-result/molecule-result';
import { ProductDetailPage }     from './pages/product-detail/product-detail';
import { SelectMoleculePage }    from './pages/select-molecule/select-molecule';
import { SettingsPage }          from './pages/settings/settings';
import { SynchronizePage }       from './pages/synchronize/synchronize';
import { ApplicationService }    from './shared/providers/application-service';
import { AuthService }           from './shared/providers/auth-service';
import { BuildInfoService }      from './shared/providers/build-info.service';
import { CartService }           from './shared/providers/cart-service';
import { DataService }           from './shared/providers/data-service';
import { DocumentService }       from './shared/providers/document-service';
import { LangService }           from './shared/providers/lang-service';
import { TranslateLoader }       from '@ngx-translate/core';
import { TranslateModule }       from '@ngx-translate/core';
import { TranslateHttpLoader }   from '@ngx-translate/http-loader';

// Components
import { MyApp }                 from './app.component';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    HomeMenuPage,
    GascomsuptionPage,
    GasmixturesPage,
    GasselectorPage,
    GasselectorPhonePage,
    InformationPage,
    SettingsPage,
    SynchronizePage,
    ProductDetailPage,
    AddToCartPage,
    CompensatedVacuumPage,
    GasFlushingPage,
    CalculatorResultsPage,
    KeyPointsPage,
    ContactPage,
    CreateAccountPage,
    KeyPointDetailPage,
    LegalTermsPage,
    SelectMoleculePage,
    FindCompetitorPage,
    DirectSearchPage,
    MixturesResultPage,
    MoleculeResultPage,
    CartPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
    IonicModule.forRoot(MyApp, {
      scrollAssist: false,
      autoFocusAssist: false
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    HomeMenuPage,
    GascomsuptionPage,
    GasmixturesPage,
    GasselectorPage,
    GasselectorPhonePage,
    InformationPage,
    SettingsPage,
    SynchronizePage,
    ProductDetailPage,
    AddToCartPage,
    CompensatedVacuumPage,
    GasFlushingPage,
    CalculatorResultsPage,
    KeyPointsPage,
    ContactPage,
    CreateAccountPage,
    KeyPointDetailPage,
    LegalTermsPage,
    SelectMoleculePage,
    FindCompetitorPage,
    DirectSearchPage,
    MixturesResultPage,
    MoleculeResultPage,
    CartPage
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApplicationService,
    CartService,
    AuthService,
    DocumentService,
    LangService,
    DataService,
    GoogleAnalytics,
    BuildInfoService
  ]
})
export class AppModule {}


export function HttpLoaderFactory(http: HttpClient)
{
  return new TranslateHttpLoader(http);
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts